const AVATAR_COLORS = [
  '#0891B2', '#059669', '#D97706', '#DC2626',
  '#7C3AED', '#DB2777', '#2563EB', '#CA8A04',
]

export function colorFromUserId(userId: string): string {
  let hash = 0
  for (let i = 0; i < userId.length; i++) {
    hash = ((hash << 5) - hash + userId.charCodeAt(i)) | 0
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length]!
}

export function initialsFromName(name: string): string {
  if (!name) return '?'
  const parts = name.split(/[\s_-]+/).filter(Boolean)
  if (parts.length >= 2) {
    return (parts[0]![0]! + parts[1]![0]!).toUpperCase()
  }
  return name.slice(0, 2).toUpperCase()
}
